// removed by extract-text-webpack-plugin
module.exports = {"links":"settings-modal__links___2mKbe"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/settings/settings-modal.scss
// module id = 1364
// module chunks = 0